import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiZeistRotterdamAirportPage() {
  return (
    <CityAirportTemplate
      city="Zeist"
      airport="rotterdam"
      airportName="Rotterdam The Hague Airport"
      price={72.50}
      distance="62 km"
      duration="50-55 minuten"
    />
  );
}
